import { CURRENT_SERVER } from '@/constants/domains'
import VueCookie from 'vue-cookie'
const axios = require('axios')

export default {
  gmailActionsAuth: function (domain) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER
    })
    return instCred.post('gmailActions/auth', domain)
  },
  gmailActionsLogout: function ({email}) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.post('gmailActions/logout', {email})
  },
  getByToken: function (ip, country, country_code) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      withCredentials: true,
      headers: {
        ip,
        country,
        country_code,
      }
    })
    return instCred.get('users/getByToken')
  },
  gmailMailingAuth: function (domain) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.post('mailing/auth', domain)
  },
  gmailHrAuth: function (domain) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.post('hr/credentials/auth', domain)
  },

  gmailClientAuth: function (domain) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.post('clientCredentials/auth', domain)
  },
  gmailProjectAuth: function (domain) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.post('project/credentials/auth', domain)
  },
  gmailAcademyAuth: function (domain) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.post('academy/credentials/auth', domain)
  },
  gmailMailing: function (company) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': company
      }
    })
    return instCred.get('mailing')
  },
  gmailHr: function (company) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': company
      }
    })
    return instCred.get('hr/credentials')
  },
  gmailAcademy: function (company) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': company
      }
    })
    return instCred.get('academy/credentials')
  },
  gmailClient: function (company) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': company
      }
    })
    return instCred.get('clientCredentials')
  },
  gmailProject: function (company) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': company
      }
    })
    return instCred.get('project/credentials')
  },
  gmailMailingLogout: function ({_id, company}) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': company
      }
    })
    return instCred.delete(`mailing/${_id}`)
  },
  gmailHrLogout: function ({_id, company}) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': company
      }
    })
    return instCred.delete(`hr/credentials/${_id}`)
  },
  gmailClientLogout: function ({_id, company}) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': company
      }
    })
    return instCred.delete(`clientCredentials/${_id}`)
  },
  gmailProjectLogout: function ({_id, company}) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': company
      }
    })
    return instCred.delete(`project/credentials/${_id}`)
  },
  gmailAcademyLogout: function ({_id, company}) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': company
      }
    })
    return instCred.delete(`academy/credentials/${_id}`)
  },
}



// WEBPACK FOOTER //
// ./src/api/Gmail/api.js